import React, { useState } from "react";
import useForm from "./useForm";
import saveSearchService from "./saveSearchService";

export default function Form(props) {

    const { values, handleChange, handleSubmit } = useForm(onSave);
    const [error, setError] = useState("");

    values.searchContext = props.searchContext;

    function onSearchSaved() {
        document.body.dispatchEvent(new CustomEvent("save-search:saved", { detail: {} }));
        if (props.onSaved) props.onSaved({ name: values.name });
    }

    function onSave() {
        saveSearchService(props.apiUrl, values)
            .then((response) => {
                if (response.ok) {
                    onSearchSaved();
                }
                else {
                    setError(response.errors.map(x => x.message).join(","));
                }
            }).catch(() => {
                setError(props.translations.couldNotSave);
            });
    }

    return (
        <form onSubmit={handleSubmit}>
            <h3>{props.translations.letStarted}</h3>
            <div className="form-group">
                <label>{props.translations.nameSearch}</label>
                <input className="form-control" type="text" name="name" required={true} onChange={handleChange} />
            </div>
            {props.canReceiveAlerts &&
                <div className="form-group">
                    <label className="col-form-label-sm email-alerts-label">{props.translations.emailAlerts}</label>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input form-control-sm" type="radio" name="emailAlerts" id="emailAlertsYes"
                            value="true" onChange={handleChange} checked={values.emailAlerts === "true"} />
                    <label className="form-check-label col-form-label-sm" htmlFor="emailAlertsYes">{props.translations.yes}</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input form-control-sm" type="radio" name="emailAlerts" id="emailAlertsNo"
                            value="false" onChange={handleChange} checked={values.emailAlerts !== "true"} />
                    <label className="form-check-label col-form-label-sm" htmlFor="emailAlertsNo">{props.translations.no}</label>
                    </div>
                </div>
            }
            <button type="submit" className="btn btn-primary">{props.translations.saveSearch}</button>
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
        </form>
    );
}